import React from "react";
import * as styles from "./VideoSection.module.scss";
import WidenVideoPlayer, { WidenVideoPlayerProps } from "./WidenVideoPlayer";

const VideoSection: React.FC<WidenVideoPlayerProps> = (props) => {
  return (
    <div className={styles.box}>
      <WidenVideoPlayer {...props} />
    </div>
  );
};

export default VideoSection;
